import { CircularProgress, DialogTitle } from "@mui/material";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React, { Component } from "react";
import { fetchTradeFormEventsByTradeFormId } from "../api/trade.js";
import { STATUS_APPROVED } from "../util/constants.js";
import {
  format_DOW_ShortMonth_Date_Year,
  format_LongMonth_Date_Year_Time,
  getShiftTime
} from "../util/dateTimeFormatter.js";
import { getScrubbedTradeFormEvents } from "../util/tradeFormEventScrubber";
import SlideUpTransition from "./fundamentals/SlideUpTransition";
import StarsCloseIconButton from "./fundamentals/StarsCloseIconButton.jsx";

export class TradeDialogDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeFormEventList: [],
      isTradeFormEventListLoading: true,
      isTradeFormEventListError: false,
      isFirstLoad: true,
    };
  }

  componentDidMount() {
    this.setState({ isFirstLoad: true });
  }

  componentDidUpdate(prevProps) {
    if (this.state.isFirstLoad) {
      fetchTradeFormEventsByTradeFormId(this.props.trade.tradeFormId, this.props.eid, this.props.isAdminPage)
        .then((res) => res.json())
        .then((result) => {
          let scrubbedTradeFormEvents = getScrubbedTradeFormEvents(result.tradeFormEvents);
          this.setState({
            tradeFormEventList: scrubbedTradeFormEvents,
            isTradeFormEventListLoading: false,
            isFirstLoad: false,
          });
        })
        .catch((err) => {
          console.error("error happened!", err);
          this.setState({
            isTradeFormEventListLoading: false,
            isTradeFormEventListError: true,
            isFirstLoad: false,
          });
        });
    }
  }

  handleClickDialogOpen(event) {
    this.props.onClickDialogOpen(event);
  }

  handleClickDialogClose(event, reason) {
    if (reason && reason === "backdropClick") return;
    this.props.onClickDialogClose(event, reason);
  }

  getNumApprovedEvents(tradeFormEventList) {
    let approvedEventCount = 0;
    for (let i = 0; i < tradeFormEventList.length; i++) {
      if (tradeFormEventList[i].tradeStatus === STATUS_APPROVED) {
        approvedEventCount++;
      }
    }
    return approvedEventCount;
  }

  renderEventStatusHistory() {
    if (this.state.tradeFormEventList) {
      return this.state.tradeFormEventList.map((tradeFormEvent) => {
        if (!tradeFormEvent.flags.isAdditionalApproved) {
          return (
            <Paper className="status-history-event" key={tradeFormEvent.eventId}>
              <Grid item xs={12}>
                <div className="bold-text">
                  {tradeFormEvent.modifiedByEid === ""
                    ? tradeFormEvent.tradeStatus
                    : tradeFormEvent.tradeStatus +
                      " - " +
                      tradeFormEvent.modifiedByLastName +
                      ", " +
                      tradeFormEvent.modifiedByFirstName}
                </div>
                {tradeFormEvent.cannedReason ? <div>Reason: {tradeFormEvent.cannedReason}</div> : ""}
                {tradeFormEvent.reasonComments ? <div>Comments: {tradeFormEvent.reasonComments}</div> : ""}
                <div>{format_LongMonth_Date_Year_Time(tradeFormEvent.createdAt)}</div>
              </Grid>
            </Paper>
          );
        }
        return "";
      });
    }
  }

  render() {
    return (
      <Dialog
        className="detail-dialog"
        fullWidth
        maxWidth="md"
        open={this.props.isDialogOpen}
        TransitionComponent={SlideUpTransition}
        keepMounted
        onClose={this.handleClickDialogClose.bind(this)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <StarsCloseIconButton onClick={this.handleClickDialogClose.bind(this)} />
        </DialogTitle>
        <DialogContent className="detail-dialog-content">
          <DialogContentText component={"div"} id="alert-dialog-slide-description">
            <Grid container>
              <Grid item xs={12} sm={6}>
                <Paper className="detail-dialog-section">
                  <Typography component={"div"}>
                    <Box className="detail-dialog-section-title">Trade Information</Box>
                  </Typography>
                  <Grid container>
                    <Grid item xs={6}>
                      <div>Reference #</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.referenceNumber}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Type</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.tradeFormType}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Latest Status</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.tradeStatus}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Station</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.station}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Shift Workgroup</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.workgroup}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={7}>
                      <div>Trade Between Agent &amp; Sup</div>
                    </Grid>
                    <Grid item xs={5}>
                      <div className="detail-dialog-right-text">
                        {this.props.trade.isSupervisorInvolved ? "Yes" : "No"}
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
                <Paper className="detail-dialog-section">
                  <Typography component={"div"}>
                    <Box className="detail-dialog-sub-section-title">Employee #1</Box>
                  </Typography>
                  <Grid container>
                    <Grid item xs={6}>
                      <div>Name</div>
                    </Grid>
                    <Grid item xs={6}>
                      {" "}
                      <div className="detail-dialog-right-text">
                        {this.props.trade.offeredEmployeeLastName}, {this.props.trade.offeredEmployeeFirstName}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>ID</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.offeredEmployeeId}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Workgroup</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.offeredEmployeeWorkgroup}</div>
                    </Grid>
                    {this.props.trade.requestedShiftStart ? (
                      <Grid container>
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>
                        <Grid item xs={6}>
                          <div>Shift Date</div>
                        </Grid>
                        <Grid item xs={6}>
                          <div className="detail-dialog-right-text">
                            {format_DOW_ShortMonth_Date_Year(this.props.trade.requestedShiftStart)}
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>
                        <Grid item xs={6}>
                          <div>Shift Time</div>
                        </Grid>
                        <Grid item xs={6}>
                          <div className="detail-dialog-right-text">
                            {getShiftTime(this.props.trade.requestedShiftStart) +
                              "-" +
                              getShiftTime(this.props.trade.requestedShiftEnd)}
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>
                        <Grid item xs={6}>
                          <div>Relief Shift</div>
                        </Grid>
                        <Grid item xs={6}>
                          <div className="detail-dialog-right-text">
                            {this.props.trade.isRequestedReliefShift ? "Yes" : "No"}
                          </div>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Paper>
                <Paper className="detail-dialog-section">
                  <Typography component={"div"}>
                    <Box className="detail-dialog-sub-section-title">Employee #2</Box>
                  </Typography>
                  <Grid container>
                    <Grid item xs={6}>
                      <div>Name</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">
                        {this.props.trade.requestedEmployeeLastName}, {this.props.trade.requestedEmployeeFirstName}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>ID</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.requestedEmployeeId}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Workgroup</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">{this.props.trade.requestedEmployeeWorkgroup}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Shift Date</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">
                        {format_DOW_ShortMonth_Date_Year(this.props.trade.offeredShiftStart)}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Shift Time</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">
                        {getShiftTime(this.props.trade.offeredShiftStart) +
                          "-" +
                          getShiftTime(this.props.trade.offeredShiftEnd)}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={6}>
                      <div>Relief Shift</div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="detail-dialog-right-text">
                        {this.props.trade.isOfferedReliefShift ? "Yes" : "No"}
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper className="detail-dialog-section">
                  <Typography component={"div"}>
                    <Box className="detail-dialog-section-title">Status History</Box>
                  </Typography>
                  {this.state.isTradeFormEventListLoading ? (
                    <CircularProgress />
                  ) : (
                    <Grid container>{this.renderEventStatusHistory()}</Grid>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
}

export default TradeDialogDesktop;
